"use strict";
module.exports = {
    entityModel: 'invoice',
    events: {
        INVOICE_UPDATED: 'INVOICE_UPDATED',
        INVOICE_CREATED: 'INVOICE_CREATED',
    },
    actions: {
        get: 'v1.invoice.get',
        list: 'v1.invoice.list',
        writeInvoice: 'v1.invoice.writeInvoice',
        ensureInvariants: 'v1.invoice.ensureInvariants',
        upsert: 'v1.invoice.upsert',
        upsertWhenEmpty: 'v1.invoice.upsertWhenEmpty',
        updateWhenEmpty: 'v1.invoice.updateWhenEmpty',
        update: 'v1.invoice.update',
    },
    invoiceOrigins: {
        supplier: 'supplier',
        export: 'export',
        customer: 'customer',
        systembolaget: 'systembolaget',
        internal: 'internal',
        whitelabel: 'whitelabel',
        purchasing: 'purchasing',
        stockfiller: 'stockfiller',
        dropshipping: 'dropshipping',
        returnToSupplier: 'returnToSupplier',
    },
    invoiceRows: {},
};
